import { Routes, Route } from "react-router-dom";
import Assistant from "./Assistant";
import Sources from "./Sources";
import { useAuth } from "../utils/AuthContext";
import { useTokenExpiryCheck } from "../utils/AuthTokenChecker";
import { SidebarProvider } from "./ui/sidebar";
import AppSidebar from "./AppSidebar";
import { BreadcrumbProvider } from "./BreadcrumbContext";
import { useTheme } from "@/components/ui/theme-provider";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

// Create a client

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60, // 60s before data is considered “stale”
      retry: (failureCount, error: any) => {
        if (error?.status === 404) return false;
        return failureCount < 2;
      },
      refetchOnWindowFocus: false,
    },
  },
});

function App() {
  const { token, logout, currentAccount } = useAuth();
  const { setTheme } = useTheme();
  setTheme("system"); //update on refresh

  // will be triggered only if the user's auth token has expired
  useTokenExpiryCheck(token, () => {
    console.warn("Token expired, forcing logout.");
    logout(currentAccount);
  });

  //console.log(`User is: ${JSON.stringify(user)}`);

  return (
    <QueryClientProvider client={queryClient}>
      <div className="w-full h-full xl:pl-12">
        <SidebarProvider defaultOpen={false}>
          <AppSidebar />
          <BreadcrumbProvider>
            <main className="flex flex-col w-full">
              <Routes>
                <Route path="sources/*" element={<Sources />} />
                <Route path="assistant/:conversationId?" element={<Assistant />} />
                <Route path="*" element={<Assistant />} />
              </Routes>
            </main>
          </BreadcrumbProvider>
        </SidebarProvider>
      </div>
    </QueryClientProvider>
  );
}

export default App;
